import { useState, useEffect, useCallback } from "react";
import { NavLink as NavLinkRRD, Link, useLocation, useNavigate } from "react-router-dom";
import { fetchAxios, postAxios, postNoauth, postWithFiles } from 'Lib/GetAxios';
import { CMM } from '../../Lib/Cmm.js';

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";


const currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 14);

const Sidebar = (props) => {
  const navigate = useNavigate();

  const [collapseOpen, setCollapseOpen] = useState();
  const [menu1, setMenu1] = useState(false);
  const [menu2, setMenu2] = useState(false);
  const [data, setData] = useState(false);

  const location = useLocation();
  const pathname = location.pathname;

  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };


  useEffect(() => {

    if (menu1 && pathname.substring(0, 14) != '/admin/chatbot') {
      setMenu1(false);
    }
    if (menu2 && pathname.substring(0, 11) != '/admin/user') {
      setMenu2(false);
    }
    lodeData();

  }, [pathname]);

  //알림 데이터 받아오기
  const lodeData = useCallback(() => {

    fetchAxios(`${CMM.SERVER_URL_API}/admin/noti_list`,
      {
        pageno: 1,
      })
      .then((res) => {
        if (res != 'ERROR') {
          // console.log(res);

          setData(res[0][0].cre_dt);
          console.log(res[0][0]);

        }
      })
      .catch((e) => {
        console.log('error::', e.message)
      })
  }, [data]);

  // 날짜 비교 함수
  const isWithinTwoWeeks = (dateString) => {
    const givenDate = new Date(dateString);
    return givenDate >= currentDate;
  };

  const { bgColor, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light bg-white"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <div className="pt-0 ml-2 flex justify-content-between"
          >
            <div>
              <span
                style={{ cursor: 'pointer', outline: 'none' }}
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/admin/chatBorder');
                }}>
                <img
                  alt={logo.imgAlt}
                  className="navbar-brand-img pr-4"
                  src={logo.imgSrc}
                />
              </span>

              <span className=" d-inline-block" style={{ justifyItems: 'end' }}>
                <div className=" rounded-circle bg-white" style={{ padding: '10px' }} >
                  {
                    (isWithinTwoWeeks(data)) ?
                      <svg className="my-2 " width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: 'pointer', outline: 'none' }}
                        tabIndex="0"
                        onClick={(e) => {
                          e.preventDefault();
                          // window.alert('::::::::::::::::::::');
                          navigate('/admin/notification');
                        }}>
                        <circle cx="23.5" cy="2.5" r="2.5" fill="#EC3939" />
                        <path d="M22.739 18.5323C22.074 17.4292 21.0856 14.3079 21.0856 10.2312C21.0856 7.78291 20.0757 5.43493 18.2782 3.70375C16.4807 1.97257 14.0427 1 11.5006 1C8.9585 1 6.52052 1.97257 4.72299 3.70375C2.92545 5.43493 1.91561 7.78291 1.91561 10.2312C1.91561 14.309 0.925959 17.4292 0.261 18.5323C0.0911909 18.8127 0.00116852 19.1314 1.12995e-05 19.456C-0.00114593 19.7806 0.0866032 20.0998 0.254409 20.3814C0.422215 20.663 0.664144 20.8969 0.955799 21.0597C1.24745 21.2225 1.57852 21.3083 1.91561 21.3086H6.80515C7.02629 22.3507 7.61439 23.2873 8.46998 23.96C9.32558 24.6326 10.3961 25 11.5006 25C12.6051 25 13.6756 24.6326 14.5312 23.96C15.3868 23.2873 15.9749 22.3507 16.196 21.3086H21.0856C21.4226 21.3081 21.7535 21.2221 22.045 21.0593C22.3365 20.8964 22.5782 20.6624 22.7459 20.3809C22.9136 20.0994 23.0012 19.7803 23 19.4557C22.9988 19.1312 22.9088 18.8127 22.739 18.5323ZM11.5006 23.1548C10.9061 23.1546 10.3263 22.977 9.84096 22.6464C9.35561 22.3157 8.9886 21.8484 8.79044 21.3086H14.2108C14.0126 21.8484 13.6456 22.3157 13.1602 22.6464C12.6749 22.977 12.0951 23.1546 11.5006 23.1548ZM1.91561 19.4623C2.83816 17.9346 3.83261 14.3944 3.83261 10.2312C3.83261 8.27256 4.64048 6.39417 6.07851 5.00923C7.51654 3.62429 9.46692 2.84623 11.5006 2.84623C13.5343 2.84623 15.4847 3.62429 16.9227 5.00923C18.3607 6.39417 19.1686 8.27256 19.1686 10.2312C19.1686 14.391 20.1606 17.9311 21.0856 19.4623H1.91561Z" fill="black" />
                      </svg>
                      :
                      <svg className="mt-2" width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg"
                        style={{ cursor: 'pointer', outline: 'none' }}
                        onClick={(e) => {
                          e.preventDefault();
                          // window.alert('::::::::::::::::::::');
                          navigate('/admin/notification');
                        }}>
                        <path d="M22.739 18.5323C22.074 17.4292 21.0856 14.3079 21.0856 10.2312C21.0856 7.78291 20.0757 5.43493 18.2782 3.70375C16.4807 1.97257 14.0427 1 11.5006 1C8.9585 1 6.52052 1.97257 4.72299 3.70375C2.92545 5.43493 1.91561 7.78291 1.91561 10.2312C1.91561 14.309 0.925959 17.4292 0.261 18.5323C0.0911909 18.8127 0.00116852 19.1314 1.12995e-05 19.456C-0.00114593 19.7806 0.0866032 20.0998 0.254409 20.3814C0.422215 20.663 0.664144 20.8969 0.955799 21.0597C1.24745 21.2225 1.57852 21.3083 1.91561 21.3086H6.80515C7.02629 22.3507 7.61439 23.2873 8.46998 23.96C9.32558 24.6326 10.3961 25 11.5006 25C12.6051 25 13.6756 24.6326 14.5312 23.96C15.3868 23.2873 15.9749 22.3507 16.196 21.3086H21.0856C21.4226 21.3081 21.7535 21.2221 22.045 21.0593C22.3365 20.8964 22.5782 20.6624 22.7459 20.3809C22.9136 20.0994 23.0012 19.7803 23 19.4557C22.9988 19.1312 22.9088 18.8127 22.739 18.5323ZM11.5006 23.1548C10.9061 23.1546 10.3263 22.977 9.84096 22.6464C9.35561 22.3157 8.9886 21.8484 8.79044 21.3086H14.2108C14.0126 21.8484 13.6456 22.3157 13.1602 22.6464C12.6749 22.977 12.0951 23.1546 11.5006 23.1548ZM1.91561 19.4623C2.83816 17.9346 3.83261 14.3944 3.83261 10.2312C3.83261 8.27256 4.64048 6.39417 6.07851 5.00923C7.51654 3.62429 9.46692 2.84623 11.5006 2.84623C13.5343 2.84623 15.4847 3.62429 16.9227 5.00923C18.3607 6.39417 19.1686 8.27256 19.1686 10.2312C19.1686 14.391 20.1606 17.9311 21.0856 19.4623H1.91561Z" fill="black" />
                      </svg>
                  }
                </div>
              </span>
            </div>
          </div>
        ) : null}
        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none">
            <Row>

              {logo ? (
                <Col className="collapse-brand " xs="6">
                  {logo.innerLink ? (
                    <Link to={logo.innerLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </Link>
                  ) : (
                    <a href={logo.outterLink}>
                      <img alt={logo.imgAlt} src={logo.imgSrc} />
                    </a>
                  )}
                </Col>
              ) : null}
              <Col className="collapse-close" xs="6">
                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
          </div>
          {/* Navigation */}
          <Nav navbar>
            <NavItem>
              <NavLink
                to="/admin/chatBorder"
                tag={NavLinkRRD}
                onClick={closeCollapse}
              >
                <i className="ni ni-tv-2 text-gray" />
                채팅
              </NavLink>
              <NavLink
                to="/admin/keyword"
                tag={NavLinkRRD}
                onClick={closeCollapse}
              >
                <i className="ni ni-planet text-blue" />
                키워드 관리
              </NavLink>
              <NavLink
                to="/admin/answer"
                tag={NavLinkRRD}
                onClick={closeCollapse}
              >
                <i className="fas fa-envelope text-orange" />
                답변 관리
              </NavLink>
              <div id="dropdownToggle"
                onClick={(e) => setMenu1(prev => !prev)}
                className={`pl-4 d-flex align-items-center w-100  p-1 py-2 text-sm  border-0  rounded-lg  bg-white
                ${(menu1 || pathname.substring(0, 14) == '/admin/chatbot') ? 'text-black' : 'text-black-50'}`}
                aria-controls="dropdown-chatbot" data-collapse-toggle="dropdown-chatbot">
                <i className="ni ni-tablet-button text-black" />
                <span className="flex-1 ml-4 text-start whitespace-nowrap" sidebar-toggle-item>
                  챗봇</span>
              </div>
              {(menu1 || pathname.substring(0, 14) == '/admin/chatbot') &&
                <><NavLink
                  to="/admin/chatbot-start"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                >
                  <i className="" />
                  시작하기
                </NavLink><NavLink
                  to="/admin/chatbot-profile"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                >
                    <i className="" />
                    챗봇 관리
                  </NavLink></>
              }
              <div type="button" id="dropdownToggle"
                onClick={(e) => setMenu2(prev => !prev)}
                className={`pl-4 d-flex align-items-center w-100  p-1 py-2 text-sm  border-0  rounded-lg  bg-white
                ${(menu2 || pathname.substring(0, 11) == '/admin/user') ? 'text-black' : 'text-black-50'}`}
                aria-controls="dropdown-users" data-collapse-toggle="dropdown-users">
                <i className="ni ni-single-02 text-yellow" />
                <span className="flex-1 ml-4 text-start whitespace-nowrap" sidebar-toggle-item>
                  관리자</span>
              </div>
              {(menu2 || pathname.substring(0, 11) == '/admin/user') &&
                <><NavLink
                  to="/admin/user-profile"
                  tag={NavLinkRRD}
                  onClick={closeCollapse}
                >
                  <i className="" />
                  관리자 프로필
                </NavLink>
                  <NavLink
                    to="/auth/user-password"
                    tag={NavLinkRRD}
                    onClick={closeCollapse}
                  >
                    <i className="" />
                    비밀번호 변경
                  </NavLink></>
              }
              <button
                onClick={(e) => {
                  sessionStorage.clear();

                  navigate("/auth/login");
                }}
                id="no-hover"
                className={' cursor-pointer mt-5 pl-4 d-flex align-items-center w-100  p-1 py-2 text-sm  border-0  rounded-lg  bg-white'}
                aria-controls="dropdown-chatbot" data-collapse-toggle="dropdown-chatbot">
                <span className="flex-1 ml-4 text-start whitespace-nowrap text-black-50 " sidebar-toggle-item>
                  로그아웃</span>
              </button>
              <style>
                {`#no-hover:hover {
                    background-color: white !important;
                  }`}
              </style>
            </NavItem>
          </Nav>
        </Collapse>
      </Container>
    </Navbar >
  );
};


// Sidebar.propTypes = {
//   // links that will be displayed inside the component
//   routes: PropTypes.arrayOf(PropTypes.object),
//   logo: PropTypes.shape({
//     // innerLink is for links that will direct the user within the app
//     // it will be rendered as <Link to="...">...</Link> tag
//     innerLink: PropTypes.string,
//     // outterLink is for links that will direct the user outside the app
//     // it will be rendered as simple <a href="...">...</a> tag
//     outterLink: PropTypes.string,
//     // the image src of the logo
//     imgSrc: PropTypes.string.isRequired,
//     // the alt for the img
//     imgAlt: PropTypes.string.isRequired,
//   }),
// };

export default Sidebar;
